// extracted by mini-css-extract-plugin
export var boxItems = "_78-1";
export var boxItemsLg = "_78-2";
export var button = "_78-7";
export var buttonHoverless = "_78-9";
export var buttonLg = "_78-8";
export var filterGroupBox = "_78-0";
export var icon = "_78-3";
export var iconSecondary = "_78-6";
export var iconWrapper = "_78-4";
export var iconWrapperLg = "_78-5";
export var truncatedLabel = "_78-a";